module.exports = __webpack_public_path__ + "static/media/Inicio RECESO.7904b187.svg";